import axiosInstance from "../utils/axiosInstance";

interface GetJobOutputTextResponse {
  text?: string;
  contentTextKey?: string;
  outputKey?: string;
}

export interface JobOutputTextResult {
  text: string;
  contentTextKey: string;
  /**
   * The S3 key of the real rendered output document (e.g.
   * `text-transform/<userId>/text_transform_<jobId>.docx`). This is the correct
   * download target — `contentTextKey` is an internal `.txt` cache the download
   * guard rejects (Trello #404).
   */
  outputKey: string;
}

export const getJobOutputText = async (jobId: string): Promise<JobOutputTextResult> => {
  try {
    const response = await axiosInstance.get<GetJobOutputTextResponse>(`/jobs/${jobId}/output-text`);
    return {
      text: response.data.text?.trim() || "",
      contentTextKey: response.data.contentTextKey?.trim() || "",
      outputKey: response.data.outputKey?.trim() || "",
    };
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Failed to load output text.");
  }
};
